import { ChakraFlex } from '@equip.health/ui';
import { useFormikContext } from 'formik';
import {
  EditAttributeData,
  EditLevelAttributeData,
  EditTreatmentOverviewFormData,
} from '~/lib/types/notes/EditTreatmentOverviewFormData';
import { EditTreatmentOverviewFormExplanationsStepAttributeRow } from './EditTreatmentOverviewFormExplanationsStepAttributeRow';

// Do not modify the order of keys in this object — it determines the display order in the modal
const EDIT_TREATMENT_OVERVIEW_FORM_ATTRIBUTE_EXPLANATION_MAP: Record<
  keyof EditTreatmentOverviewFormData,
  { label: string; placeholder: string }
> = {
  modality: {
    label: 'Modality',
    placeholder: 'Provide explanation for modality change',
  },
  form: {
    label: 'Form',
    placeholder: 'Provide explanation for form change',
  },
  phaseStage: {
    label: 'Phase/stage',
    placeholder: 'Provide explanation for phase/stage change',
  },
  level: {
    label: 'Level',
    placeholder: 'Provide explanation for level change',
  },
  discussionOfWeight: {
    label: 'Weight discussion',
    placeholder: 'Provide explanation for weight discussion change',
  },
  saferStage: {
    label: 'SAFER stage',
    placeholder: 'Provide explanation for SAFER stage change',
  },
};

type Props = {
  oldValues: EditTreatmentOverviewFormData;
};

export const EditTreatmentOverviewFormExplanationsStep = ({
  oldValues,
}: Props) => {
  const { values: formValues, setValues } =
    useFormikContext<EditTreatmentOverviewFormData>();

  return (
    <ChakraFlex flexDirection="column" gap="24px" width="100%">
      {(
        Object.keys(
          EDIT_TREATMENT_OVERVIEW_FORM_ATTRIBUTE_EXPLANATION_MAP,
        ) as Array<keyof EditTreatmentOverviewFormData>
      )
        .filter((attributeKey) => {
          const formValue = formValues[attributeKey];
          return !(
            attributeKey === 'form' &&
            (formValue === null || formValue === undefined)
          );
        })
        .map(
          (attributeKey) =>
            (formValues[attributeKey] ?? '') !==
              (oldValues[attributeKey] ?? '') && (
              <EditTreatmentOverviewFormExplanationsStepAttributeRow
                attributeKey={attributeKey}
                key={attributeKey}
                label={
                  EDIT_TREATMENT_OVERVIEW_FORM_ATTRIBUTE_EXPLANATION_MAP[
                    attributeKey
                  ].label
                }
                newAttribute={formValues[attributeKey]}
                oldAttribute={oldValues[attributeKey]}
                onExplanationValueChange={(newExplanation) =>
                  setValues((prev) => {
                    const newState = { ...prev };
                    newState[attributeKey] = {
                      ...newState[attributeKey],
                      explanation: newExplanation,
                    } as EditAttributeData & EditLevelAttributeData;
                    return newState;
                  })
                }
                placeholder={
                  EDIT_TREATMENT_OVERVIEW_FORM_ATTRIBUTE_EXPLANATION_MAP[
                    attributeKey
                  ].placeholder
                }
              />
            ),
        )}
    </ChakraFlex>
  );
};
